export default __webpack_public_path__ + "static/media/BackArrowPaymentDesktop.e9294e47.svg";